import { render, staticRenderFns } from "./ContractSavingsCollectionFinishCollection.vue?vue&type=template&id=e7eb0e50&"
import script from "./ContractSavingsCollectionFinishCollection.vue?vue&type=script&lang=ts&"
export * from "./ContractSavingsCollectionFinishCollection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
